// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  useEmulators: true,
  firebase: {
    apiKey: 'AIzaSyBZ5aMw9ufs2ydjO-hnhg5gLuM0Hiw4SA4',
    authDomain: 'hendyghsta-1989.firebaseapp.com',
    databaseURL: 'https://hendyghsta-1989.firebaseio.com',
    projectId: 'hendyghsta-1989',
    storageBucket: 'hendyghsta-1989.appspot.com',
    messagingSenderId: '758713531494'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
